import request from '@/utils/request'
import DefaultModel from '@/models/perfilOrigen'
import { format } from 'date-fns'

const state = {
    lista: [],
    datos: new DefaultModel.BaseForm()
}

const getters = {
    lista: (_state) => (_state.lista.length > 0 ? _state.lista.sort((a, b) => (a.nombre > b.nombre ? 1 : -1)) : [])
}

const mutations = {
    SET_LISTA: (state, payload) => {
        state.lista = payload
    },
    RESET_FORM: (state, payload) => {
        state.datos = new DefaultModel.BaseForm()
    },
    UPDATE_DATOS: (state, payload) => {
        state.datos = payload
    }
}

const actions = {
    async obtenerLista({ commit }, payload) {
        const { data } = await request({
            url: '/api/private/PerfilOrigen',
            method: 'GET'
        })

        console.log('obtenerLista perfilOrigen', data)
        commit('SET_LISTA', data.payload)
    },
    async obtenerById({ commit }, payload) {
        const { data } = await request({
            url: `/api/private/PerfilOrigen/${payload.id}`,
            method: 'GET'
        })

        console.log('obtenerById perfilOrigen', data)
        return data
    },
    async registrar({ commit }, payload) {
        console.log('post_payload perfilOrigen', payload)
        const { data } = await request({
            url: '/api/private/PerfilOrigen/',
            method: 'POST',
            data: payload
        })
        console.log('data', data)
    },
    async actualizar({ commit, rootState }, payload) {
        const datos = rootState.usuarios.userLogin
        payload.usuarioModificacion = datos.usuario
        console.log('post_payload perfilOrigen', payload)

        const { data } = await request({
            url: `/api/private/PerfilOrigen/${payload.id}`,
            method: 'PUT',
            data: payload
        })
        console.log('data', data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
